import axios from 'axios'
import constants from '../../../constants'

const getCorpChildrenTrainings = async (customerNumber: string) => {
  const { data } = await axios.get(`${constants.ONTRAQ_API_URL}/api2/${customerNumber}/customer-trainings/corp-children`)
  return data
}

const getCorpTrainingByYear = async (customerNumber: string) => {
  const { data } = await axios.get(`${constants.ONTRAQ_API_URL}/api2/${customerNumber}/customer-trainings/corp-training-by-year-report`)
  return data
}

export { getCorpChildrenTrainings, getCorpTrainingByYear }
